import colorAxis8Level from './colorAxisLevel'
const dataDisplayOptions = [
  {
    label: 'Public Indicators',
    options: [
      {
        value: 'forecast_level',
        tagKey: 'forecast_level',
        tagValue: 'data_value',
        label: 'Eligibility Rate',
        colorAxis: colorAxis8Level,
        mapTitle: 'US Eligibility Rate',
        mapSubTitle: undefined,
        indicatorName: 'Forecasts',
        legend: {
          enabled: false,
          title: {
            text: 'US Eligibility Rate',
          },
        },
      },
    ],
  },
]

export default dataDisplayOptions
